namespace advisorop.components.servicer {
    
    class DocumentUploaderController {

        $router;
        accountDocuments: boolean = false;
        investorDocuments: boolean = false;
        operationsDataFiles: boolean = false;
        typeOfUploader = "";

        lovs: Array<domains.ILOV> = [];
        
        static $inject = ["generalService","identityService","servicerService"];
        constructor(private generalService: services.GeneralService,
            private identityService: services.IdentityService,
            private servicerService: services.ServicerService) {
        }

        $onInit(): void {
        }
      
        $routerOnActivate(next, previous) {
            if (next.params.type)
            {
                if (next.params.type == "account") {
                    this.accountDocuments = true;
                    this.typeOfUploader = "ACCOUNT DOCUMENT UPLOAD";
                } else if (next.params.type == "investor") {
                    this.investorDocuments = true;
                    this.typeOfUploader = "INVESTOR DOCUMENT UPLOAD";
                } else if (next.params.type == "operations") {
                    this.operationsDataFiles = true;
                    this.typeOfUploader = "OPERATIONS DATA FILE IMPORT";
                }
            }
        }
    }

    class DocumentUploader implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public $routeConfig: any;

        constructor() {
            this.bindings = {
                "$router": "<"
            };
            this.controller = DocumentUploaderController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/servicer-module/components/document-uploader.html';            
        }
    }
    angular.module(Constants.APP).component("documentUploader", new DocumentUploader());
}